import React, { useContext } from 'react'
import { useFeature } from '@news-mono/web-common'
import { ConfigurationContext } from '@news-mono/web-common'
import { getBaseUrl } from '@news-mono/web-common'

import { ArticleBlockContent } from '../../../publication/ArticleBlockContent/ArticleBlockContent'
import { Footnote } from '../../../publication/Footnote/Footnote'

import { getFundingType } from '../../../templates/Publication/lib/get-funding-type'

import { getCanonicalLink } from '../../../templates/Publication/lib/get-canonical-link'
import { PublicationProps } from '../../../templates/Publication/Publication.props'
import { RelatedContent } from '../../../content/RelatedContent/RelatedContent'
import { LinkBanner } from '../../../banners/LinkBanner/LinkBanner'
import {
    StyledGrid,
    StyledCell,
    StyledArticleContent,
    StyledFlexCell,
    StyledInsetCell,
    StyledArticleContentFooter,
} from './TheWestFeature.styled'
import { Byline } from '../../../publication/Byline/Byline'
import { useSectionMetaInfo } from '../../../__helpers/use-section-meta'

interface CellProps {
    offset?: {
        position: 'top'
        value: '50%'
    }
}

export const featurePublicationPageType = 'feature-publication'

export function TheWestFeature(props: PublicationProps & CellProps) {
    const publication = props.data
    const content = publication.content
    const canonicalLink = getCanonicalLink(publication)
    const { publicUrl } = useContext(ConfigurationContext)
    const sectionMeta = useSectionMetaInfo()
    const articleUrl = `${getBaseUrl(publicUrl, sectionMeta)}/${
        publication.primaryTopic.id
    }/${publication.slug}`

    const relatedItems =
        props.relatedPublications && props.relatedPublications.items

    const fundingType = getFundingType(
        publication,
        useFeature('story-classification'),
    )

    return (
        <StyledGrid itemProp="articleBody">
            <StyledInsetCell>
                <Byline
                    profile={publication.profile}
                    text={publication.byline}
                    timestamp={publication.publicationDate}
                    fundingType={fundingType}
                    source={publication.source}
                    isFullWidth={true}
                    url={articleUrl}
                    title={publication.heading}
                    requiredAccess={publication.requiredAccess}
                    allowCommenting={publication.allowCommenting}
                />
            </StyledInsetCell>

            <StyledCell>
                {content && (
                    <StyledArticleContent>
                        <ArticleBlockContent
                            blocks={content}
                            targetedContentElement={
                                props.targetedContent &&
                                props.targetedContent.position === 'inline'
                                    ? props.targetedContent.element
                                    : undefined
                            }
                            inlinePositionedContent={
                                props.inlinePositionedContent
                            }
                            onEvent={props.onEvent}
                            log={props.log}
                            publicationPathname={props.location.pathname}
                            adUnitPath={props.adUnitPath}
                            requiredAccess={publication.requiredAccess}
                        />
                        {canonicalLink && (
                            <Footnote
                                text="Originally published as "
                                link={canonicalLink}
                            />
                        )}
                    </StyledArticleContent>
                )}

                <StyledArticleContentFooter>
                    <LinkBanner
                        url={`https://emails.thewest.com.au/subscribe/index.html?utm_source=${
                            sectionMeta.Hostname || 'TheWest'
                        }&utm_campaign=ArticleLinkBanner&utm_content=ArticleLinkBanner`}
                        message="Get the latest news delivered to your inbox."
                        cta="Sign up for our emails"
                        verticalGutters={['md', 'md']}
                    />

                    {relatedItems && (
                        <StyledFlexCell>
                            <RelatedContent
                                items={relatedItems}
                                onEvent={props.onEvent}
                            />
                        </StyledFlexCell>
                    )}
                </StyledArticleContentFooter>
            </StyledCell>
        </StyledGrid>
    )
}
